<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/cooperationList' }">合作规划</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="addNews">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="editDetails(list.approval_status)">编辑</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details details_link">
                        <el-form-item label="code：">
                            <el-input v-model="list.code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="合作方：">
                            <div class="read_only read_only_link">
                                <span @click="partnerClick(list.partner_rid)">{{ list.partner_name }}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="产品：">
                            <div class="read_only read_only_link">
                                <span @click="productClick(list.product_rid)">
                                    {{ list.product_name }}
                                </span>
                            </div>
                        </el-form-item>
                        <el-form-item label="产品代码：">
                            <div class="read_only read_only_link">
                                <span @click="productClick(list.product_rid)">{{ list.product_code }}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="省份：">
                            <el-input v-model="list.province_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="城市：">
                            <el-input v-model="list.city_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="特征码：">
                            <el-input v-model="list.feature_code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="开始日期：">
                            <el-input v-model="list.start_date" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="结束日期：">
                            <el-input v-model="list.end_date" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="时效性：">
                            <el-input v-model="list.timeliness_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="审批状态：">
                            <el-input
                                v-model="list.approval_status_label"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="返利前单位底价下限：">
                            <el-input
                                v-model="list.unit_base_price_before_rebate_lb"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="返利类型：">
                            <el-input v-model="list.rebate_type_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="单位返利上限：">
                            <el-input v-model="list.unit_rebate_ub" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="代理类型：">
                            <el-input v-model="list.agency_type_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="返利后单位底价下限：">
                            <el-input
                                v-model="list.unit_base_price_after_rebate_lb"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="MEPR：">
                            <el-input
                                v-model="list.marginal_expense_provision_rate"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="VATR：">
                            <el-input v-model="list.value_added_tax_rate" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="价格控制匹配条件：">
                            <div class="read_only read_only_link" @click="priceClick(list.price_control_rid)">
                                {{ list.price_control_rid }}
                            </div>
                        </el-form-item>
                        <el-form-item label="提交人职位：">
                            <el-input
                                v-model="list.submission_hierarchy_name"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="创建人：" prop="created_by">
                            <div class="read_only">{{ list.created_by ? list.created_by : '' }} </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by">
                            <div class="read_only">{{ list.updated_by ? list.updated_by : '' }} </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="合作价格" name="2">
                    <vCooperativePriceList :postList="postList" v-if="flag"></vCooperativePriceList>
                </el-collapse-item>
                <el-collapse-item disabled title="流程行" name="3">
                    <!-- <div class="main_list">
                        <div class="flex">
                            <div class="main_header_btns">
                                <el-popover placement="left" trigger="click" class="top_btn" width="200px">
                                    <el-checkbox
                                        :indeterminate="isIndeterminateLine"
                                        v-model="checkAllLine"
                                        @change="handleCheckAllChangeLine"
                                        >全选</el-checkbox
                                    >
                                    <el-checkbox-group
                                        v-model="colOptionsLine"
                                        style="display: flex; flex-direction: column"
                                        @change="handleCheckedCitiesChangeLine"
                                    >
                                        <el-checkbox v-for="item in colSelectLine" :label="item" :key="item"></el-checkbox>
                                    </el-checkbox-group>
                                    <el-button slot="reference" size="mini" icon="el-icon-setting">设置</el-button>
                                </el-popover>
                            </div>
                        </div>
                        <el-table :data="dataList" border style="width: 100%" ref="tableDataRefLine" element-loading-text="数据拼命加载中">
                            <el-table-column
                                v-if="colDataLine[0].istrue"
                                prop="rel_name"
                                label="对象名称"
                                align="left"
                                show-overflow-tooltip
                                width="120px"
                            >
                            </el-table-column>
                            <el-table-column v-if="colDataLine[1].istrue" prop="name" label="流程行名称" align="left" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                v-if="colDataLine[2].istrue"
                                prop="status_label"
                                label="状态"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                v-if="colDataLine[3].istrue"
                                prop="type_label"
                                label=" 类型"
                                align="left"
                                show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="colDataLine[4].istrue"
                                prop="operator_hierarchy_names"
                                label="可审批职位"
                                align="left"
                                show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="colDataLine[5].istrue"
                                prop="operator_name"
                                label="审批人"
                                align="left"
                                show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="colDataLine[6].istrue"
                                prop="operator_hierarchy_name"
                                label="审批人职位"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                v-if="colDataLine[7].istrue"
                                prop="operation_label"
                                label="执行意见"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                v-if="colDataLine[8].istrue"
                                prop="comment"
                                label="意见说明"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                v-if="colDataLine[9].istrue"
                                prop="sequence"
                                label="序号"
                                align="left"
                                show-overflow-tooltip
                                width="180px"
                            ></el-table-column>
                            <el-table-column
                                v-if="colDataLine[10].istrue"
                                prop="next_sequence"
                                label="下一步序号"
                                align="left"
                                show-overflow-tooltip
                                width="180px"
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="colDataLine[11].istrue"
                                prop="operator_number"
                                label="执行人数"
                                align="left"
                                show-overflow-tooltip
                                width="180px"
                            >
                            </el-table-column>
                            <el-table-column label="操作" width="180">
                                <template slot-scope="scope" style="height: 100%">
                                    <div v-show="scope.row.wait_me_approve == 1">
                                        <button
                                            type="button"
                                            class="el-button el-button--text el-button--small"
                                            @click="okPassLine(3, scope)"
                                        >
                                            <span>通过</span>
                                        </button>
                                        <button
                                            type="button"
                                            class="el-button el-button--text el-button--small"
                                            @click="okPassLine(4, scope)"
                                        >
                                            <span>拒绝</span>
                                        </button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-dialog
                            v-dialogDrag
                            :close-on-click-modal="false"
                            title="审核意见"
                            :visible.sync="dialogVisibleLine"
                            width="30%"
                        >
                            <el-input type="textarea" :rows="2" placeholder="请输入审核意见" v-model="comment"> </el-input>
                            <span slot="footer" class="dialog-footer">
                                <el-button
                                    @click="
                                        dialogVisibleLine = false;
                                        comment = '';
                                    "
                                    >取 消</el-button
                                >
                                <el-button type="primary" @click="subData">确 定</el-button>
                            </span>
                        </el-dialog>
                    </div> -->
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vCooperativePriceList from '../../listComponent/riskcontrol/cooperativeprice/cooperativePriceListComponent.vue';
export default {
    inject: ['reload'],
    name: 'cooperationDetail',
    components: {
        vCooperativePriceList
    },
    data() {
        return {
            flag: false,
            postList: {
                code: true,
                demander_rid: true,
                timeliness: true,
                approval_status: true,
                feature_code: true,
                date: true,
                params: {
                    tab_type: 2,
                    partner_scheme_rid: ''
                }
            },
            comment: '',
            dialogVisibleLine: false,
            dataList: [],
            dataType: '',
            //控制列
            colDataLine: [
                { title: '对象名称', istrue: true },
                { title: '流程行名称', istrue: true },
                { title: '状态', istrue: true },
                { title: '类型', istrue: true },
                { title: '可审批职位', istrue: true },
                { title: '审批人', istrue: true },
                { title: '审批人职位', istrue: true },
                { title: '执行意见', istrue: true },
                { title: '意见说明', istrue: true },
                { title: '序号', istrue: true },
                { title: '下一步序号', istrue: true },
                { title: '执行人数', istrue: true }
            ],
            colOptionsLine: [
                '对象名称',
                '流程行名称',
                '状态',
                '类型',
                '可审批职位',
                '审批人',
                '审批人职位',
                '执行意见',
                '意见说明',
                '序号',
                '下一步序号',
                '执行人数'
            ], //默认全选
            // 筛选列
            colSelectLine: [
                '对象名称',
                '流程行名称',
                '状态',
                '类型',
                '可审批职位',
                '审批人',
                '审批人职位',
                '执行意见',
                '意见说明',
                '序号',
                '下一步序号',
                '执行人数'
            ],
            checkAllLine: true,
            isIndeterminateLine: false,
            selectedLine: [],
            headerTitle: '合作规划详情',
            list: {},
            activeNames: ['1', '2', '3'],
            rid: '',
            rids: []
        };
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.postList.params.partner_scheme_rid = this.$route.query.id;
        this.getDetail(); //获取详情
        this.getLineList(); //获取流程列表
        this.flag = false;
        this.$$nextTick(() => {
            this.flag = true;
        });
    },
    watch: {
        colOptionsLine(valArr) {
            var arr = this.colSelectLine.filter((i) => valArr.indexOf(i) < 0); // 未选中
            this.colDataLine.filter((i) => {
                if (arr.indexOf(i.title) != -1) {
                    i.istrue = false;
                    this.$nextTick(() => {
                        this.$refs.tableDataRefLine.doLayout();
                    });
                } else {
                    i.istrue = true;
                    this.$nextTick(() => {
                        this.$refs.tableDataRefLine.doLayout();
                    });
                }
            });
        },
        $route(to, from) {
            this.rid = to.query.id;
            this.postList.params.partner_scheme_rid = to.query.id;
            this.reload();
            this.getLineList(); //获取流程列表
        }
    },
    methods: {
        //type == 3审批通过 type ==4 拒绝
        okPassLine(type, scope) {
            this.dataType = type;
            this.dialogVisibleLine = true;
            this.rids.push(scope.row.rel_rid);
        },
        //提交通过拒绝弹窗
        subData() {
            if (this.dataType == 3) {
                //此处为通过
                let postData = {
                    rids: this.rids,
                    approval_status: 3,
                    comment: this.comment
                };
                this.$api
                    .partnerSchemeBatchAudit(postData)
                    .then((res) => {
                        this.dialogVisibleLine = false;
                        if (res.code == 0) {
                            this.$message({
                                message: '审批通过!',
                                type: 'success'
                            });
                            this.getDetail(); //获取详情
                            this.getLineList(); //获取流程列表
                        }
                    })
                    .catch((error) => {
                        this.dialogVisibleLine = false;
                        
                    });
            } else if (this.dataType == 4) {
                //此处为拒绝
                let postData = {
                    rids: this.rids,
                    approval_status: 4,
                    comment: this.comment
                };
                this.$api
                    .partnerSchemeBatchAudit(postData)
                    .then((res) => {
                        this.dialogVisibleLine = false;
                        if (res.code == 0) {
                            this.$message({
                                message: '已拒绝!',
                                type: 'waring'
                            });
                            this.getDetail(); //获取详情
                            this.getLineList(); //获取流程列表
                        }
                    })
                    .catch((error) => {
                        this.dialogVisibleLine = false;
                        
                    });
            }
        },
        //获取流程行列表
        getLineList() {
            let params = {
                for_detail: 1,
                rel_type: 'partner_scheme',
                rel_rid: this.rid
            };
            this.$api
                .procedureLineDetailsList(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.dataList = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //全选设置列表 列显示
        handleCheckAllChangeLine(val) {
            this.isIndeterminateLine = false;
            if (val) {
                this.colOptionsLine = [
                    '对象名称',
                    '流程行名称',
                    '状态',
                    '类型',
                    '可审批职位',
                    '审批人',
                    '审批人职位',
                    '执行意见',
                    '意见说明',
                    '序号',
                    '下一步序号',
                    '执行人数'
                ];
                this.colSelectLine = [
                    '对象名称',
                    '流程行名称',
                    '状态',
                    '类型',
                    '可审批职位',
                    '审批人',
                    '审批人职位',
                    '执行意见',
                    '意见说明',
                    '序号',
                    '下一步序号',
                    '执行人数'
                ];
            } else {
                this.colOptionsLine = [];
            }
        },
        //单选设置列表 列显示
        handleCheckedCitiesChangeLine(value) {
            let checkedCount = value.length;
            this.checkAllLine = checkedCount === this.colDataLine.length;
            this.isIndeterminateLine = checkedCount > 0 && checkedCount < this.colDataLine.length;
        },
        //查看价格控制
        priceClick(rid) {
            this.$router.push({
                path: 'priceControlDetail',
                query: {
                    id: rid
                }
            });
        },
        //删除
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .partnerSchemeDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/cooperationList'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //复制页面
        copy() {
            this.$router.push({
                path: 'cooperationEdit',
                query: {
                    type: 5,
                    id: this.rid
                }
            });
        },
        //合作方详情跳转
        partnerClick(rid) {
            this.$router.push({
                path: 'partnerDetails',
                query: {
                    id: rid
                }
            });
        },
        //产品详情跳转
        productClick(rid) {
            this.$router.push({
                path: 'productListDetails',
                query: {
                    id: rid
                }
            });
        },
        //前往编辑页面
        editDetails(status) {
            if (status == 3) {
                this.$message({
                    message: '审批状态为已批准的不能修改！',
                    type: 'warning'
                });
            } else {
                this.$router.push({
                    path: '/cooperationEdit',
                    query: {
                        type: 1,
                        id: this.rid
                    }
                });
            }
        },
        //新增
        addNews() {
            this.$router.push({
                path: 'cooperationEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //详情
        getDetail() {
            let params = {
                rid: this.rid
            };
            this.$api
                .partnerSchemeDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.code;
                    }
                })
                .catch((error) => {
                    
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>